import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b21432a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", { class: "sr-only" }, "Oversigt over sammenligninger", -1))
const _hoisted_3 = {
  key: 0,
  class: "bg-primary text-color-white"
}
const _hoisted_4 = ["id", "onClick"]
const _hoisted_5 = { class: "nowrap" }
const _hoisted_6 = {
  fill: "none",
  height: "12",
  viewBox: "0 0 12 12",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["id"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Handlinger", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["headers"]
const _hoisted_14 = ["data-cy-name"]
const _hoisted_15 = ["headers"]
const _hoisted_16 = ["headers"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = ["headers"]
const _hoisted_19 = ["headers", "aria-labelledby"]
const _hoisted_20 = { class: "overflow-menu overflow-menu--open-left" }
const _hoisted_21 = ["data-js-target"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  fill: "white",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#more-vert" })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["id"]
const _hoisted_25 = { class: "overflow-list" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" })
], -1))
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#trash-can" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", {
      id: _ctx.id,
      "aria-label": "oversigt over sammenligninger",
      class: "table w-percent-100"
    }, [
      _hoisted_2,
      _createElementVNode("thead", null, [
        (_ctx.tableHeaders)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders, (tableHeader, index) => {
                return (_openBlock(), _createElementBlock("th", {
                  id: `table-header-${index}-${_ctx.id}`,
                  key: tableHeader.sortKey,
                  class: "clickable",
                  scope: "col",
                  onClick: ($event: any) => (_ctx.sort(tableHeader.sortKey))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(tableHeader.headline) + " ", 1),
                    (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                      _createElementVNode("path", {
                        fill: _ctx.currentSort === tableHeader.sortKey && _ctx.currentSortDir === 'asc' ? 'white' : '',
                        "clip-rule": "evenodd",
                        d: "M9.99419 4.75003L6.00003 0.755859L2.00586 4.75003H9.99419Z",
                        "fill-rule": "evenodd",
                        stroke: "white"
                      }, null, 8, _hoisted_7),
                      _createElementVNode("path", {
                        fill: _ctx.currentSort === tableHeader.sortKey && _ctx.currentSortDir === 'desc' ? 'white' : '',
                        "clip-rule": "evenodd",
                        d: "M2.00586 7.25003L6.00003 11.2442L9.99419 7.25003H2.00586Z",
                        "fill-rule": "evenodd",
                        stroke: "white"
                      }, null, 8, _hoisted_8)
                    ]))
                  ])
                ], 8, _hoisted_4))
              }), 128)),
              _createElementVNode("th", {
                id: `table-header-action-${_ctx.id}`,
                scope: "col"
              }, _hoisted_11, 8, _hoisted_9)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.sortedComparisons.length === 0 || !_ctx.sortedComparisons)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
              _createElementVNode("td", {
                headers: _ctx.getRowDataHeaderDefinition(_ctx.id),
                class: "table-no-content",
                colspan: "4"
              }, [
                _createVNode(_component_SimpleText, { textKey: 'comparison.overview.no-items-in-list' }, null, 8, ["textKey"])
              ], 8, _hoisted_13)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedComparisons, (comparison) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: comparison.id,
            "data-cy-name": comparison.name
          }, [
            _createElementVNode("td", {
              headers: `table-header-0-${_ctx.id}`,
              "data-title": "Navn",
              style: {"width":"25%"}
            }, _toDisplayString(comparison.name), 9, _hoisted_15),
            _createElementVNode("td", {
              headers: `table-header-1-${_ctx.id}`,
              "data-title": "Beregninger brugt",
              style: {"width":"50%"}
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comparison.calculationNames, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.id
                }, [
                  _createTextVNode(_toDisplayString(item.calculationName), 1),
                  _hoisted_17
                ], 64))
              }), 128))
            ], 8, _hoisted_16),
            _createElementVNode("td", {
              headers: `table-header-2-${_ctx.id}`,
              "data-title": "Bemærkninger",
              class: "align-text-left-max-size",
              style: {"width":"25%"}
            }, _toDisplayString(_ctx.limitText(comparison.description, 200)), 9, _hoisted_18),
            _createElementVNode("td", {
              headers: `table-header-action-${_ctx.id}`,
              "aria-labelledby": `table-header-action-${_ctx.id}`,
              "data-title": "Handlinger"
            }, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: _normalizeClass([`overflow-menu-table`, "button-overflow-menu js-dropdown"]),
                  "data-js-target": `forecast-${comparison.id}-actions-overflow`,
                  "aria-expanded": false,
                  "aria-haspopup": "true",
                  "aria-label": "Åbn handlinger for sammenligning"
                }, _hoisted_23, 8, _hoisted_21),
                _createElementVNode("div", {
                  id: `forecast-${comparison.id}-actions-overflow`,
                  "aria-hidden": "true",
                  class: "overflow-menu-inner",
                  role: "menu"
                }, [
                  _createElementVNode("ul", _hoisted_25, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        class: "edit-button",
                        to: "/comparison/create-comparison",
                        onClick: ($event: any) => (_ctx.$emit('edit-comparison', comparison)),
                        "aria-label": "Rediger sammenligning"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SimpleText, { textKey: 'forecast.overview.menuitem.open' }, null, 8, ["textKey"]),
                          _hoisted_26
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        class: "delete-button",
                        onClick: ($event: any) => (_ctx.$emit('delete-comparison', comparison)),
                        "aria-label": "Slet sammenligning"
                      }, [
                        _createVNode(_component_SimpleText, { textKey: 'forecast.overview.menuitem.delete' }, null, 8, ["textKey"]),
                        _hoisted_28
                      ], 8, _hoisted_27)
                    ])
                  ])
                ], 8, _hoisted_24)
              ])
            ], 8, _hoisted_19)
          ], 8, _hoisted_14))
        }), 128))
      ])
    ], 8, _hoisted_1)
  ]))
}